import React from "react";
import Pagebackground from "../images/pagebackground.jpg";
import "../styles.css";

const Backgroundimage = () => (
  <img src={Pagebackground} alt="Web App Background" id="background" />
);

export default Backgroundimage;
